import { useLocalStorage } from '../useLocalStorage'
import { LOCALSTORAGE_KEY_COMPARABLE_PRODUCTS } from '../../constants'
import { getTomorrowDate } from '../../utils/date'
import { useConfig } from '../../providers/config'
import { useProducts } from './useProducts'
import { useSortCollection } from '../useSortCollection'

export const useComparableProducts = () => {
	const {
		catalog: {
			products: {
				comparable: { limit },
			},
		},
	} = useConfig()

	const [storageValue, setStorageValue] = useLocalStorage(LOCALSTORAGE_KEY_COMPARABLE_PRODUCTS, [])

	const isComparable = storageValue.length < limit

	const addItem = ({ id }) => {
		setStorageValue([...storageValue, id], getTomorrowDate())
	}

	const removeItem = ({ id }) => {
		setStorageValue(
			storageValue.filter((item) => item !== id),
			getTomorrowDate()
		)
	}

	const isInComparison = ({ id }) => {
		return !!storageValue.find((item) => item === id)
	}

	const { products, error, loading, mutate, cancel, cancelled } = useProducts({
		limit,
		offset: 0,
		where: {
			id: {
				inq: storageValue,
			},
		},
		paused: storageValue.length === 0,
	})

	const comparableProducts = useSortCollection({
		collection: storageValue.length === 0 ? [] : products || null,
		sortedValues: storageValue,
	})

	return {
		comparableProductsIds: storageValue,
		comparableProducts: comparableProducts,
		addItem,
		removeItem,
		isInComparison,
		isComparable,
		error,
		loading,
		mutate,
		cancel,
		cancelled,
	}
}
